var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"src":_vm.url,"width":"100%","height":"100%","frameborder":"0","allowfullscreen":""},on:{"load":_vm.load}})
}
var staticRenderFns = []

export { render, staticRenderFns }